import styles from "./ProductModule.module.less";
import React, { useState, useEffect, useRef} from "react";
import { useCartStore, useCorpInfoStore } from '@/stores'
import { utils, apis } from '@/utils';
import { ModuleItemProps } from "@/types/interfaces";
import ProductCell from "../ProductCell/ProductCell";
import Masonry from 'react-masonry-css'
import { InfiniteScroll } from 'antd-mobile'
import useRefState from '@/hooks/useRefState'

const { to, px2rem, capitalizeFirstLetter } = utils;
const { corpApi, productApi } = apis;

interface ModuleProps {
  module: ModuleItemProps;
}
const ProductModule: React.FC<ModuleProps> = (props) => {
  const { corpModuleId } = props.module;
  const { corpInfo } = useCorpInfoStore()
  const { cart } = useCartStore()
  const { corpId, customerId } = corpInfo
  const { cartId } = cart
  const [moduleTitle, setModuleTitle] = useState('');
  const [productList, setProductList] = useState([]);
  const [cellWidth, setCellWidth] = useState('');
  const refMasonry = useRef<HTMLDivElement | null>(null);
  const [hasMore, setHasMore] = useState(false);
  const [pageNum, setPageNum, pageNumRef] = useRefState(1);
  const [corpNavigationId, setCorpNavigationId] = useState('');

  const breakpointColumnsObj = {
    default: 2,
  }
  /*
    * 获取模块详情
    */
  async function getModuleDetail() {
    if (!corpId || !corpModuleId) return;

    // 获取详情
    const [err, res] = await to(
      corpApi.queryHomeModuleDetail({ corpId, corpModuleId }),
    );

    if (err || !res.data || !res.data[0]) return;

    const { corpNavigationId, title } = res.data[0];

    if (!corpNavigationId) return;
    
    setCorpNavigationId(corpNavigationId);
    setModuleTitle(title || '');
    getProductList(corpNavigationId);
  }

  /*
     * 请求列表数据
     */
  async function getProductList(corpNavigationId: string = '') {
    const params = {
      corpId,
      corpNavigationId,
      cartId,
      customerId,
      pageNum: pageNumRef.current,
      pageSize: 20,
    };
  

    const [err, res] = await to(productApi.queryHomeSuggestDetail(params));

    if (err || !res.data) {
      setHasMore(false);
      return;
    }

    const { data: list, code, pages } = res;
    if (pageNumRef.current === 1) {
      setProductList(list || [])
    } else {
      setProductList(productList.concat(...(list || [])))
    }

    if (
      (Array.isArray(list) && pageNumRef.current >= pages) ||
      err ||
      (code === 0 && !list)
    ) {
      setHasMore(false)
    } else {
      setHasMore(true)
    }
  }

  async function loadMore() {
    setPageNum(pageNum + 1)
    await getProductList(corpNavigationId);
  }

  useEffect(() => {
    getModuleDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props])

  useEffect(() => {
    if (refMasonry.current) {
      const offset = window.getComputedStyle(refMasonry.current)

      setCellWidth(`calc(${window.screen.width / 2}px - ${offset.paddingLeft} - ${px2rem(8)})`)
    }
  }, [])

  return (
    <div className={styles['product-wrap']}>
      <div className={styles['product-hd']}>
        <h2 className={styles['product-title'] + ' ep-2'}>{capitalizeFirstLetter(moduleTitle)}</h2>
      </div>
      <div className={styles['product-bd']} ref={refMasonry}>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className={styles['my-masonry-grid']}
          columnClassName={styles['my-masonry-grid_column']}
        >
          {productList.map((item, index) => (
            <ProductCell item={item} index={index} key={index} cellWidth={cellWidth} />
          ))}
        </Masonry>
        {hasMore && <InfiniteScroll threshold={350} loadMore={loadMore} hasMore={hasMore} />}
      </div>
    </div>
  );
}

export default ProductModule